import script from "./OrderSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderSearch.vue?vue&type=script&setup=true&lang=ts"

import "./OrderSearch.vue?vue&type=style&index=0&id=bd05f3ba&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd05f3ba"]])

export default __exports__